module.exports = __webpack_public_path__ + "img/zs6.199c3ebb.png";